import { ChevronDown, Folder, FolderPlus } from "lucide-react";
import type { Project } from "../../api/types.js";
import { projectDisplayName } from "../shared/constants.js";
import type { FloatingPosition } from "./useFloatingMenu.js";
import { ProjectMenu } from "./ProjectMenu.js";

export function ProjectList({
  projects,
  currentProjectId,
  openProjectMenuId,
  projectMenuPosition,
  openProjectMenu,
  closeProjectMenu,
  closeSessionMenu,
  closeFloatingMenus,
  onAddProject,
  onProjectChange,
  onRenameProject,
  onDeleteProject
}: {
  projects: Project[];
  currentProjectId: string;
  openProjectMenuId: string | null;
  projectMenuPosition: FloatingPosition | null;
  openProjectMenu: (projectId: string, rect: DOMRect, width: number, height: number) => void;
  closeProjectMenu: () => void;
  closeSessionMenu: () => void;
  closeFloatingMenus: () => void;
  onAddProject: () => void;
  onProjectChange: (projectId: string) => void;
  onRenameProject: (project: Project) => void;
  onDeleteProject: (project: Project) => void;
}) {
  return (
    <section className="sidebar-group" aria-label="项目与实验">
      <button className="sidebar-group-title active" type="button">
        <span>项目&实验</span>
        <ChevronDown className="tool-chevron" size={15} />
      </button>
      <div className="project-list">
        <button className="history-item" type="button" onClick={onAddProject}>
          <FolderPlus size={17} />
          <span>新项目</span>
        </button>
        {projects.length === 0 && <p>暂无项目</p>}
        {projects.map((project) => {
          const active = project.id === currentProjectId;
          const menuOpen = openProjectMenuId === project.id;
          return (
            <div key={project.id} className={`project-row ${active ? "active" : ""} ${menuOpen ? "menu-open" : ""}`} data-project-menu-root>
              <button className="history-item project-row-main" type="button" onClick={() => { closeFloatingMenus(); onProjectChange(project.id); }}>
                <Folder size={17} />
                <span>{projectDisplayName(project)}</span>
              </button>
              <ProjectMenu
                project={project}
                menuOpen={menuOpen}
                menuPosition={projectMenuPosition}
                openProjectMenu={openProjectMenu}
                closeProjectMenu={closeProjectMenu}
                closeSessionMenu={closeSessionMenu}
                onRenameProject={onRenameProject}
                onDeleteProject={onDeleteProject}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
}
